"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var View = /*#__PURE__*/function () {
  function View(template) {
    _classCallCheck(this, View);

    this._activeChildElements = [];
    this._template = template;

    this._exposeNamedElements();
  }

  _createClass(View, [{
    key: "_exposeNamedElements",
    value: function _exposeNamedElements() {
      var _this = this;

      Object.keys(this._template.namedElements).forEach(function (elementName) {
        _this[elementName] = _this._template.namedElements[elementName];
      });
    }
  }, {
    key: "activate",
    value: function activate(region) {
      this._region = region;

      this._moveDomChildrenToRegion();
    }
  }, {
    key: "_moveDomChildrenToRegion",
    value: function _moveDomChildrenToRegion() {
      var _this2 = this;

      this._template.childNodes.forEach(function (element) {
        _this2._activeChildElements.push(element);

        _this2._region.appendChild(element);
      });
    }
  }, {
    key: "deactivate",
    value: function deactivate() {
      this._template.reclaimChildren();

      this._activeChildElements = [];
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this3 = this;

      var result = {};
      Object.keys(this._template.propertyElements).forEach(function (propertyName) {
        var element = _this3._template.propertyElements[propertyName];
        result[propertyName] = _this3._getElementValue(element);
      });
      return result;
    }
  }, {
    key: "_getElementValue",
    value: function _getElementValue(element) {
      if (element.nodeName === 'INPUT') {
        if (element.type === 'checkbox' || element.type === 'radio') return element.checked;
        return element.value;
      }

      return element.innerHTML;
    }
  }, {
    key: "setData",
    value: function setData(data) {
      var _this4 = this;

      Object.keys(data).forEach(function (name) {
        var element = _this4._template.propertyElements[name];

        _this4._setElementValue(element, data[name]);
      });
    }
  }, {
    key: "clearData",
    value: function clearData() {
      var _this5 = this;

      Object.keys(this._template.propertyElements).forEach(function (name) {
        var element = _this5._template.propertyElements[name];

        _this5._setElementValue(element, '');
      });
    }
  }, {
    key: "_setElementValue",
    value: function _setElementValue(element, value) {
      if (!element) return;

      if (element.nodeName === 'INPUT') {
        if (element.type === 'checkbox' || element.type === 'radio') element.checked = value;
        element.value = value;
      } else element.innerHTML = value;
    }
  }, {
    key: "template",
    get: function get() {
      return this._template;
    }
  }]);

  return View;
}();

exports["default"] = View;